module.exports = __webpack_public_path__ + "img/BRCA2_Neutrophils.4842b8f4.png";